
import { defineComponent } from 'vue';
import Scenes from './components/Scenes.vue';

export default defineComponent({
  name: 'Kreditojs',
  components: {
    Scenes,
  },
  setup() {
    return {
      screenplay: (window as any).screenplay,
    };
  },
});
